import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import BitrixAPI from "../api/b24";
import axios from 'axios';
import { API_URL } from '../config';
import { useHeader } from "../contexts/HeaderContext";


const ZakalkaTripsPage = () => {
  const navigate = useNavigate();
  const [trips, setTrips] = useState([]);
  const [tripFilter, setTripFilter] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");
  const { setHeaderExtras } = useHeader();
  const [loadingTrips, setLoadingTrips] = useState(false);
  const [tripDetailsData, setTripDetailsData] = useState({});
  const [loadingTripDetails, setLoadingTripDetails] = useState(new Set());
  const [showViewTripModal, setShowViewTripModal] = useState(false);
  const [viewingTrip, setViewingTrip] = useState(null);
  const [viewTripDetailsSearch, setViewTripDetailsSearch] = useState('');
  const [viewTripInfoExpanded, setViewTripInfoExpanded] = useState(false);

  // Состояния для модального окна редактирования
  const [showTripModal, setShowTripModal] = useState(false);
  const [editingTrip, setEditingTrip] = useState(null);
  const [tripDetails, setTripDetails] = useState([]); // Детали, которые УЖЕ в рейсе
  const [availableDetails, setAvailableDetails] = useState([]); // Детали доступные для добавления
  const [tripPartner, setTripPartner] = useState('Казстековид');
  const [tripDetailsSearch, setTripDetailsSearch] = useState('');
  const [availableDetailsSearch, setAvailableDetailsSearch] = useState('');
  const [creatingTrip, setCreatingTrip] = useState(false);
  const [loadingTripDetailsInModal, setLoadingTripDetailsInModal] = useState(false);
  const [loadingAvailableDetailsInModal, setLoadingAvailableDetailsInModal] = useState(false);
  const [generatingPartnerPDF, setGeneratingPartnerPDF] = useState(false);
  const [generatingViewPartnerPDF, setGeneratingViewPartnerPDF] = useState(false);

  // Состояния для системы недостач
  const [tripShortages, setTripShortages] = useState([]);
  const [loadingShortages, setLoadingShortages] = useState(false);
  const [resolvingShortageId, setResolvingShortageId] = useState(null);

  // Состояния для модального окна причины переделки
  const [showReworkModal, setShowReworkModal] = useState(false);
  const [reworkShortage, setReworkShortage] = useState(null);
  const [reworkReason, setReworkReason] = useState('');
  const [submittingRework, setSubmittingRework] = useState(false);

  // Состояния для фото рейса
  const [viewTripPhotos, setViewTripPhotos] = useState([]);
  const [loadingViewTripPhotos, setLoadingViewTripPhotos] = useState(false);

  // Загрузка рейсов
  const fetchTrips = async () => {
    try {
      setLoadingTrips(true);
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_URL}/api/zakalka-trips`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error('Ошибка загрузки рейсов');
      }

      const data = await response.json();
      console.log('📦 [ZakalkaTripsPage] Данные рейсов с сервера:', data);
      console.log('📦 [ZakalkaTripsPage] Обработанные рейсы:', data.trips || data);
      setTrips(data.trips || data);
    } catch (err) {
      console.error("Ошибка загрузки рейсов:", err);
    } finally {
      setLoadingTrips(false);
    }
  };

  // Загрузка деталей конкретного рейса
  const fetchTripDetails = async (tripId) => {
    if (loadingTripDetails.has(tripId) || tripDetailsData[tripId]) {
      return;
    }

    try {
      setLoadingTripDetails(prev => new Set(prev).add(tripId));
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_URL}/api/zakalka-trips/${tripId}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error('Ошибка загрузки деталей рейса');
      }

      const data = await response.json();
      setTripDetailsData(prev => ({
        ...prev,
        [tripId]: data.details || []
      }));
    } catch (err) {
      console.error(`Ошибка загрузки деталей рейса ${tripId}:`, err);
    } finally {
      setLoadingTripDetails(prev => {
        const newSet = new Set(prev);
        newSet.delete(tripId);
        return newSet;
      });
    }
  };

  // Загрузка недостач рейса
  const fetchTripShortages = async (tripId) => {
    try {
      setLoadingShortages(true);
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_URL}/api/zakalka-trips/${tripId}/shortages`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) throw new Error('Ошибка загрузки недостач');
      const data = await response.json();
      setTripShortages(data.shortages || []);
    } catch (err) {
      console.error('Ошибка загрузки недостач:', err);
      setTripShortages([]);
    } finally {
      setLoadingShortages(false);
    }
  };

  // Решение по недостаче
  const handleResolveShortage = async (shortageId, resolution) => {
    try {
      setResolvingShortageId(shortageId);
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_URL}/api/zakalka-shortages/${shortageId}/resolve`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ resolution })
      });

      if (!response.ok) throw new Error('Ошибка решения по недостаче');

      // Обновляем недостачи и детали
      if (viewingTrip) {
        await fetchTripShortages(viewingTrip.id);
        // Перезагружаем детали рейса чтобы обновить received_quantity
        setTripDetailsData(prev => {
          const copy = { ...prev };
          delete copy[viewingTrip.id];
          return copy;
        });
        await fetchTripDetails(viewingTrip.id);
      }
    } catch (err) {
      console.error('Ошибка решения по недостаче:', err);
      alert(`Ошибка: ${err.message}`);
    } finally {
      setResolvingShortageId(null);
    }
  };

  // Открыть модальное окно причины переделки
  const openReworkModal = (shortage) => {
    setReworkShortage(shortage);
    setReworkReason('');
    setShowReworkModal(true);
  };

  // Закрыть модальное окно причины переделки
  const closeReworkModal = () => {
    setShowReworkModal(false);
    setReworkShortage(null);
    setReworkReason('');
  };

  // Отправка детали в переделку с указанием причины
  const handleSubmitRework = async () => {
    if (!reworkShortage || !reworkReason.trim()) return;

    try {
      setSubmittingRework(true);
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_URL}/api/zakalka-shortages/${reworkShortage.id}/resolve`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ resolution: 'reprocess', notes: reworkReason.trim() })
      });

      if (!response.ok) throw new Error('Ошибка отправки в переделку');

      closeReworkModal();

      if (viewingTrip) {
        await fetchTripShortages(viewingTrip.id);
        setTripDetailsData(prev => {
          const copy = { ...prev };
          delete copy[viewingTrip.id];
          return copy;
        });
        await fetchTripDetails(viewingTrip.id);
      }
    } catch (err) {
      console.error('Ошибка отправки в переделку:', err);
      alert(`Ошибка: ${err.message}`);
    } finally {
      setSubmittingRework(false);
    }
  };

  // Загрузка фото рейса
  const fetchTripPhotos = async (tripId) => {
    try {
      setLoadingViewTripPhotos(true);
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_URL}/api/zakalka-trips/${tripId}/photos`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.ok) {
        const data = await response.json();
        setViewTripPhotos(data.photos || []);
      }
    } catch (err) {
      console.error("Ошибка загрузки фото рейса:", err);
    } finally {
      setLoadingViewTripPhotos(false);
    }
  };

  // Функция просмотра рейса
  const handleViewTrip = async (trip) => {
    try {
      setViewingTrip(trip);
      setViewTripDetailsSearch('');
      setTripShortages([]);
      setViewTripPhotos([]);
      await fetchTripDetails(trip.id);
      setShowViewTripModal(true);
      fetchTripPhotos(trip.id);
      // Загружаем недостачи для рейсов со статусом received
      if (trip.status === 'received') {
        fetchTripShortages(trip.id);
      }
    } catch (err) {
      console.error("Ошибка открытия просмотра рейса:", err);
      alert(`Ошибка: ${err.message}`);
    }
  };

  // Функция редактирования рейса
  const handleEditTrip = async (trip) => {
    // Сбрасываем состояния загрузки
    setLoadingTripDetailsInModal(false);
    setLoadingAvailableDetailsInModal(false);

    // Сразу открываем модальное окно с базовой информацией
    setEditingTrip({
      id: trip.id,
      type: trip.type,
      status: trip.status,
      notes: trip.notes || '',
      partner: trip.partner || 'Казстековид',
      details: []
    });
    setTripPartner(trip.partner || 'Казстековид');
    setTripDetails([]);
    setAvailableDetails([]);
    setShowTripModal(true);

    // Загружаем детали рейса асинхронно
    setLoadingTripDetailsInModal(true);
    try {
      const token = localStorage.getItem('token');
      const tripResponse = await fetch(`${API_URL}/api/zakalka-trips/${trip.id}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!tripResponse.ok) {
        throw new Error('Ошибка загрузки деталей рейса');
      }

      const tripData = await tripResponse.json();

      // Преобразуем детали из формата БД в формат интерфейса
      const details = tripData.details.map(d => ({
        orderId: d.order_id,
        orderNumber: d.order_number,
        detailId: d.detail_id,
        detailText: d.detail_text,
        glassType: d.glass_type,
        quantity: d.quantity,
        maxQuantity: d.quantity, // Для редактирования используем текущее количество как максимум
        isSelected: true, // При редактировании все детали выбраны по умолчанию
        inTrip: true // Флаг что деталь уже в рейсе
      }));

      setEditingTrip(prev => ({
        ...prev,
        trip_number: tripData.tripNumber,
        details: details
      }));
      setTripDetails(details);
      setLoadingTripDetailsInModal(false);

      // Загружаем доступные заказы для добавления деталей
      loadAvailableDetails(details);
    } catch (err) {
      console.error("Ошибка загрузки деталей рейса:", err);
      setLoadingTripDetailsInModal(false);
      alert(`Ошибка при загрузке деталей рейса: ${err.message}`);
    }
  };

  // Загрузка доступных деталей для добавления в рейс
  const loadAvailableDetails = async (tripDetails) => {
    setLoadingAvailableDetailsInModal(true);
    try {
      const token = localStorage.getItem('token');

      // Загружаем информацию о деталях, которые уже в других рейсах
      let detailsInOtherTrips = new Set();
      try {
        const tripsDetailsResponse = await fetch(`${API_URL}/api/zakalka-trips-details-in-use`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (tripsDetailsResponse.ok) {
          const tripsDetailsData = await tripsDetailsResponse.json();
          if (tripsDetailsData.success && tripsDetailsData.details) {
            // Создаем Set из ключей orderId_detailId для деталей в других рейсах
            // Исключаем детали текущего редактируемого рейса
            detailsInOtherTrips = new Set(
              tripsDetailsData.details
                .filter(d => d.tripId !== editingTrip?.id)
                .map(d => `${d.orderId}_${d.detailId}`)
            );
            console.log(`🚫 Детали в других рейсах: ${detailsInOtherTrips.size}`);
          }
        }
      } catch (err) {
        console.warn("Ошибка загрузки деталей в рейсах:", err);
      }

      // Загружаем доступные заказы через BitrixAPI
      const orders = await BitrixAPI.getActiveOrderszakalka();
      console.log(`📋 Загружено заказов для добавления: ${orders?.length || 0}`);

      // Собираем комбинации orderId + detailId деталей, которые уже в ТЕКУЩЕМ рейсе
      const detailsInCurrentTrip = new Set(tripDetails.map(d => `${d.orderId}_${d.detailId}`));
      console.log(`🎯 Детали уже в текущем рейсе:`, Array.from(detailsInCurrentTrip));

      // Формируем список доступных деталей (не в рейсе)
      const available = [];
      for (const order of orders || []) {
        // Загружаем детали заказа
        try {
          const detailsResponse = await axios.get(`${API_URL}/api/glass-details-fixed/${order.id}`, {
            headers: {
              'Authorization': `Bearer ${token}`
            },
            timeout: 30000
          });

          if (detailsResponse.data.success) {
            const glassDetails = detailsResponse.data.glassDetails || [];
            console.log(`📦 Заказ ${order.orderNumber || order.id}: найдено ${glassDetails.length} деталей`);

            // Добавляем только те детали, которых нет ни в текущем рейсе, ни в других рейсах
            glassDetails.forEach(detail => {
              const detailKey = `${order.id}_${detail.id}`;
              // Проверяем, что деталь не в текущем рейсе И не в других рейсах
              if (!detailsInCurrentTrip.has(detailKey) && !detailsInOtherTrips.has(detailKey)) {
                available.push({
                  orderId: order.id,
                  orderNumber: order.orderNumber || order.id,
                  detailId: detail.id,
                  detailText: detail.originalText,
                  glassType: detail.glassType,
                  quantity: 0, // По умолчанию не выбрана
                  maxQuantity: detail.quantity || 1,
                  isSelected: false, // Не выбрана
                  inTrip: false // Не в рейсе
                });
              } else if (detailsInOtherTrips.has(detailKey)) {
                console.log(`⚠️ Деталь ${detail.originalText} (заказ ${order.orderNumber || order.id}) уже в другом рейсе`);
              }
            });
          }
        } catch (detailErr) {
          console.error(`❌ Ошибка загрузки деталей заказа ${order.id}:`, detailErr);
        }
      }

      console.log(`✅ Всего доступных деталей для добавления: ${available.length}`);
      setAvailableDetails(available);
      setLoadingAvailableDetailsInModal(false);
    } catch (err) {
      console.error("Ошибка загрузки доступных деталей:", err);
      setLoadingAvailableDetailsInModal(false);
    }
  };

  // Функция удаления рейса
  const handleDeleteTrip = async (tripId) => {
    if (!confirm('Вы уверены, что хотите удалить этот рейс?')) {
      return;
    }

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_URL}/api/zakalka-trips/${tripId}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error('Ошибка удаления рейса');
      }

      await fetchTrips();
      alert('Рейс успешно удален!');
    } catch (err) {
      console.error("Ошибка удаления рейса:", err);
      alert(`Ошибка при удалении рейса: ${err.message}`);
    }
  };

  // Обработчики для модального окна редактирования рейса
  const handleTripDetailQuantityChange = (detailIndex, newQuantity) => {
    const newDetails = [...tripDetails];
    const detail = newDetails[detailIndex];
    if (newQuantity >= 0 && newQuantity <= detail.maxQuantity) {
      newDetails[detailIndex] = { ...detail, quantity: newQuantity };
      setTripDetails(newDetails);
    }
  };

  const handleTripDetailToggle = (detailIndex) => {
    const newDetails = [...tripDetails];
    newDetails[detailIndex] = { ...newDetails[detailIndex], isSelected: !newDetails[detailIndex].isSelected };
    setTripDetails(newDetails);
  };

  // Обработчики для доступных деталей
  const handleAvailableDetailQuantityChange = (detailIndex, newQuantity) => {
    const newDetails = [...availableDetails];
    const detail = newDetails[detailIndex];
    if (newQuantity >= 0 && newQuantity <= detail.maxQuantity) {
      newDetails[detailIndex] = { ...detail, quantity: newQuantity };
      setAvailableDetails(newDetails);
    }
  };

  const handleAvailableDetailToggle = (detailIndex) => {
    const newDetails = [...availableDetails];
    const detail = newDetails[detailIndex];
    newDetails[detailIndex] = { ...detail, isSelected: !detail.isSelected };
    // Если выбираем деталь, устанавливаем количество в максимум
    if (!detail.isSelected && detail.quantity === 0) {
      newDetails[detailIndex].quantity = detail.maxQuantity;
    }
    setAvailableDetails(newDetails);
  };

  // Добавить выбранные доступные детали в рейс
  const handleAddToTrip = () => {
    const selectedAvailable = availableDetails.filter(d => d.isSelected && d.quantity > 0);
    if (selectedAvailable.length === 0) {
      alert('Выберите детали для добавления в рейс');
      return;
    }

    // Добавляем выбранные детали в рейс
    const detailsToAdd = selectedAvailable.map(d => ({
      ...d,
      inTrip: true,
      isSelected: true
    }));

    const updatedTripDetails = [...tripDetails, ...detailsToAdd];
    setTripDetails(updatedTripDetails);

    // Удаляем добавленные детали из доступных
    const remainingAvailable = availableDetails.filter(d => !(d.isSelected && d.quantity > 0));
    setAvailableDetails(remainingAvailable);

    console.log(`➕ Добавлено ${detailsToAdd.length} деталей в рейс`);
  };

  // Генерация партнерского PDF для рейса в окне просмотра
  const handleGenerateViewPartnerPDF = async () => {
    try {
      setGeneratingViewPartnerPDF(true);
      const token = localStorage.getItem('token');

      // Проверяем, что детали загружены
      if (!tripDetailsData[viewingTrip.id] || tripDetailsData[viewingTrip.id].length === 0) {
        alert('Нет деталей для генерации отчета партнера');
        return;
      }

      const details = tripDetailsData[viewingTrip.id];

      // Группируем детали по заказам и толщине стекла
      const orderGroups = {};
      details.forEach(detail => {
        const orderId = detail.order_id || detail.orderId;
        const orderNumber = detail.order_number || detail.orderNumber;
        const detailText = detail.detail_text || detail.detailText;
        const quantity = detail.quantity;
        const savedGlassType = detail.glass_type || detail.glassType;

        if (!orderGroups[orderId]) {
          orderGroups[orderId] = {
            orderId: orderId,
            orderNumber: orderNumber,
            orderTitle: `Заказ ${orderNumber}`,
            groupedDetails: {},
            comments: '',
            hasSelectedDetails: true
          };
        }

        // Используем сохраненный glass_type или извлекаем толщину из текста детали
        let thickness = 'Неизвестная толщина';
        let glassType = 'Неизвестный тип';

        if (savedGlassType) {
          // Используем сохраненное значение из БД
          glassType = savedGlassType;
          const thicknessMatch = savedGlassType.match(/(\d+)\s*мм/);
          if (thicknessMatch) {
            thickness = `${thicknessMatch[1]}мм`;
          }
        } else if (detailText) {
          // Если нет сохраненного значения, извлекаем из текста
          const thicknessMatch = detailText.match(/(\d+)\s*мм/);
          if (thicknessMatch) {
            thickness = `${thicknessMatch[1]}мм`;
          }

          const typeMatch = detailText.match(/^([^\d]+?)\s*\d+\s*мм/);
          if (typeMatch) {
            glassType = typeMatch[1].trim() + ' ' + thickness;
          } else {
            const words = detailText.split(/\s+/);
            glassType = words.slice(0, 3).join(' ');
          }
        }

        if (!orderGroups[orderId].groupedDetails[thickness]) {
          orderGroups[orderId].groupedDetails[thickness] = [];
        }

        // Извлекаем размеры из текста детали
        let height = 0;
        let width = 0;
        if (detailText) {
          const sizeMatch = detailText.match(/(\d+)\s*[xх×*]\s*(\d+)/i);
          if (sizeMatch) {
            height = parseInt(sizeMatch[1]);
            width = parseInt(sizeMatch[2]);
          }
        }

        orderGroups[orderId].groupedDetails[thickness].push({
          id: detail.detail_id || detail.detailId,
          originalText: detailText,
          glassType: glassType,
          selectedQuantity: quantity,
          quantity: quantity,
          thickness: thickness,
          glassColor: glassType.replace(/\s*\d+\s*мм/g, '').trim() || 'Неизвестный цвет',
          height: height,
          width: width,
          area: height && width ? (height * width / 1000000).toFixed(2) : '0.00',
          totalArea: height && width ? (height * width * quantity / 1000000).toFixed(2) : '0.00',
          isSelected: true
        });
      });

      const ordersData = Object.values(orderGroups);

      // Отправляем запрос на сервер для генерации партнерского PDF
      const response = await axios.post(
        `${API_URL}/api/generate-zakalka-partner-pdf`,
        {
          ordersData,
          reportType: viewingTrip.type === 'shipping' ? 'отгрузки' : 'приемки',
          activeTab: viewingTrip.type === 'shipping' ? 'shipping' : 'receiving',
          isReceivingMode: viewingTrip.type === 'receiving',
          tripNumber: viewingTrip.tripNumber || `Рейс ${viewingTrip.id}`,
          partner: viewingTrip.partner,
          bitrixFields: viewingTrip.type === 'receiving' ? {
            selected: 'UF_CRM_3_1752818210443',
            comments: 'UF_CRM_3_1752818233225',
            unselectedComments: 'UF_CRM_3_1749212719306',
            responsibleComments: 'UF_CRM_3_1752818259434'
          } : {
            selected: 'UF_CRM_3_1751521756206',
            comments: 'UF_CRM_3_1751521814271',
            unselectedComments: 'UF_CRM_3_1749212719306',
            responsibleComments: 'UF_CRM_3_1751521846111'
          }
        },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          responseType: 'blob'
        }
      );

      // Создаем ссылку для скачивания PDF
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      const reportType = viewingTrip.type === 'shipping' ? 'отгрузки' : 'приемки';
      link.setAttribute('download', `zakalka-partner-${reportType}-trip-${viewingTrip.id}-${new Date().toISOString().split('T')[0]}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      console.log('✅ Партнерский PDF успешно сгенерирован (просмотр)');
    } catch (error) {
      console.error('❌ Ошибка генерации партнерского PDF:', error);
      alert(`Ошибка генерации партнерского PDF: ${error.message}`);
    } finally {
      setGeneratingViewPartnerPDF(false);
    }
  };

  // Генерация партнерского PDF для рейса в окне редактирования
  const handleGeneratePartnerPDF = async () => {
    try {
      setGeneratingPartnerPDF(true);
      const token = localStorage.getItem('token');

      // Собираем выбранные детали из рейса
      const selectedDetails = tripDetails.filter(d => d.isSelected);

      if (selectedDetails.length === 0) {
        alert('Нет выбранных деталей для генерации отчета партнера');
        return;
      }

      // Группируем детали по заказам и толщине стекла
      const orderGroups = {};
      selectedDetails.forEach(detail => {
        if (!orderGroups[detail.orderId]) {
          orderGroups[detail.orderId] = {
            orderId: detail.orderId,
            orderNumber: detail.orderNumber,
            orderTitle: `Заказ ${detail.orderNumber}`,
            groupedDetails: {},
            comments: '',
            hasSelectedDetails: true
          };
        }

        // Извлекаем толщину из типа стекла или текста детали
        let thickness = 'Неизвестная толщина';
        let glassType = 'Неизвестный тип';

        // Сначала пытаемся получить из поля glassType
        if (detail.glassType) {
          const thicknessMatch = detail.glassType.match(/(\d+)\s*мм/);
          if (thicknessMatch) {
            thickness = `${thicknessMatch[1]}мм`;
          }
          glassType = detail.glassType;
        } else if (detail.detailText) {
          // Если glassType нет, пытаемся извлечь из текста детали
          // Формат: "прозрачный 8мм" или "тонированный 6мм" и т.д.
          const thicknessMatch = detail.detailText.match(/(\d+)\s*мм/);
          if (thicknessMatch) {
            thickness = `${thicknessMatch[1]}мм`;
          }

          // Ищем тип стекла в начале строки (до размеров)
          const typeMatch = detail.detailText.match(/^([^\d]+?)\s*\d+\s*мм/);
          if (typeMatch) {
            glassType = typeMatch[1].trim() + ' ' + thickness;
          } else {
            // Если не нашли паттерн, берем первые слова
            const words = detail.detailText.split(/\s+/);
            glassType = words.slice(0, 3).join(' ');
          }
        }

        if (!orderGroups[detail.orderId].groupedDetails[thickness]) {
          orderGroups[detail.orderId].groupedDetails[thickness] = [];
        }

        // Извлекаем размеры из текста детали
        let height = 0;
        let width = 0;
        if (detail.detailText) {
          const sizeMatch = detail.detailText.match(/(\d+)\s*[xх×*]\s*(\d+)/i);
          if (sizeMatch) {
            height = parseInt(sizeMatch[1]);
            width = parseInt(sizeMatch[2]);
          }
        }

        orderGroups[detail.orderId].groupedDetails[thickness].push({
          id: detail.detailId,
          originalText: detail.detailText,
          glassType: glassType,
          selectedQuantity: detail.quantity,
          quantity: detail.quantity,
          thickness: thickness,
          glassColor: glassType.replace(/\s*\d+\s*мм/g, '').trim() || 'Неизвестный цвет',
          height: height,
          width: width,
          area: height && width ? (height * width / 1000000).toFixed(2) : '0.00',
          totalArea: height && width ? (height * width * detail.quantity / 1000000).toFixed(2) : '0.00',
          isSelected: true
        });
      });

      const ordersData = Object.values(orderGroups);

      // Отправляем запрос на сервер для генерации партнерского PDF
      const response = await axios.post(
        `${API_URL}/api/generate-zakalka-partner-pdf`,
        {
          ordersData,
          reportType: editingTrip.type === 'shipping' ? 'отгрузки' : 'приемки',
          activeTab: editingTrip.type === 'shipping' ? 'shipping' : 'receiving',
          isReceivingMode: editingTrip.type === 'receiving',
          tripNumber: editingTrip.trip_number || `Рейс ${editingTrip.id}`,
          partner: tripPartner,
          bitrixFields: editingTrip.type === 'receiving' ? {
            selected: 'UF_CRM_3_1752818210443',
            comments: 'UF_CRM_3_1752818233225',
            unselectedComments: 'UF_CRM_3_1749212719306',
            responsibleComments: 'UF_CRM_3_1752818259434'
          } : {
            selected: 'UF_CRM_3_1751521756206',
            comments: 'UF_CRM_3_1751521814271',
            unselectedComments: 'UF_CRM_3_1749212719306',
            responsibleComments: 'UF_CRM_3_1751521846111'
          }
        },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          responseType: 'blob'
        }
      );

      // Создаем ссылку для скачивания PDF
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      const reportType = editingTrip.type === 'shipping' ? 'отгрузки' : 'приемки';
      link.setAttribute('download', `zakalka-partner-${reportType}-trip-${editingTrip.id}-${new Date().toISOString().split('T')[0]}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      console.log('✅ Партнерский PDF успешно сгенерирован');
    } catch (error) {
      console.error('❌ Ошибка генерации партнерского PDF:', error);
      alert(`Ошибка генерации партнерского PDF: ${error.message}`);
    } finally {
      setGeneratingPartnerPDF(false);
    }
  };

  // Функция сохранения рейса
  const handleSaveTrip = async () => {
    try {
      setCreatingTrip(true);
      const token = localStorage.getItem('token');

      // Подготовка данных - фильтруем только выбранные детали (с галочкой)
      const selectedDetails = tripDetails.filter(d => d.isSelected);

      if (selectedDetails.length === 0) {
        alert('Пожалуйста, выберите хотя бы одну деталь для сохранения рейса (поставьте галочку)');
        setCreatingTrip(false);
        return;
      }

      const uniqueOrders = new Set(selectedDetails.map(d => d.orderId));
      const tripData = {
        type: editingTrip.type,
        partner: tripPartner,
        status: editingTrip.status,
        notes: editingTrip.notes,
        details: selectedDetails.map(d => ({
          order_id: d.orderId,
          order_number: d.orderNumber,
          detail_id: d.detailId,
          detail_text: d.detailText,
          glass_type: d.glassType,
          quantity: d.quantity
        })),
        totalOrders: uniqueOrders.size,
        totalDetails: selectedDetails.reduce((sum, d) => sum + (d.quantity || 1), 0)
      };

      // Обновление существующего рейса
      const response = await fetch(`${API_URL}/api/zakalka-trips/${editingTrip.id}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(tripData)
      });

      if (!response.ok) {
        throw new Error('Ошибка сохранения рейса');
      }

      const savedTrip = await response.json();

      // Перезагружаем список рейсов
      await fetchTrips();

      // Закрываем модальное окно
      setShowTripModal(false);
      setEditingTrip(null);
      setTripPartner('Казстековид');
      setTripDetails([]);
      setLoadingTripDetailsInModal(false);
      setLoadingAvailableDetailsInModal(false);

      alert(`Рейс ${savedTrip.trip_number} успешно обновлен!`);
    } catch (err) {
      console.error("Ошибка сохранения рейса:", err);
      alert(`Ошибка при сохранении рейса: ${err.message}`);
    } finally {
      setCreatingTrip(false);
    }
  };

  // Принять водителем
  const handleAcceptByDriver = async (tripId) => {
    if (!confirm('Принять этот рейс водителем?')) return;

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_URL}/api/zakalka-trips/${tripId}/accept-by-driver`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error('Ошибка принятия рейса');
      }

      await fetchTrips();
      alert('Рейс принят водителем!');
    } catch (err) {
      console.error("Ошибка принятия рейса:", err);
      alert(`Ошибка: ${err.message}`);
    }
  };

  // Сдать партнеру
  const handleDeliverToPartner = async (tripId) => {
    if (!confirm('Сдать этот рейс партнеру?')) return;

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_URL}/api/zakalka-trips/${tripId}/deliver-to-partner`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error('Ошибка сдачи партнеру');
      }

      await fetchTrips();
      alert('Рейс сдан партнеру закалки!');
    } catch (err) {
      console.error("Ошибка сдачи партнеру:", err);
      alert(`Ошибка: ${err.message}`);
    }
  };

  // Забрать у партнера
  const handleReceiveFromPartner = async (tripId) => {
    if (!confirm('Забрать этот рейс у партнера?')) return;

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_URL}/api/zakalka-trips/${tripId}/receive-from-partner`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error('Ошибка забора у партнера');
      }

      await fetchTrips();
      alert('Рейс забран у партнера закалки!');
    } catch (err) {
      console.error("Ошибка забора у партнера:", err);
      alert(`Ошибка: ${err.message}`);
    }
  };

  // Принять с закалки
  const handleReceiveFromZakalka = async (tripId) => {
    if (!confirm('Принять этот рейс с закалки?')) return;

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_URL}/api/zakalka-trips/${tripId}/receive-from-zakalka`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Ошибка приема с закалки');
      }

      const data = await response.json();
      await fetchTrips();

      // Обновляем viewingTrip с новым статусом
      if (viewingTrip && viewingTrip.id === tripId) {
        setViewingTrip(prev => ({ ...prev, status: 'received' }));
      }

      // Перезагружаем детали рейса
      setTripDetailsData(prev => {
        const copy = { ...prev };
        delete copy[tripId];
        return copy;
      });
      await fetchTripDetails(tripId);

      if (data.shortages && data.shortages.length > 0) {
        // Есть недостачи — показываем блок недостач (не закрываем модалку)
        setTripShortages(data.shortages);
      } else {
        // Нет недостач — стандартное поведение
        setTripShortages([]);
        alert(`Рейс принят с закалки! Укомплектовано заказов: ${data.completedOrders?.length || 0}`);
      }
    } catch (err) {
      console.error("Ошибка приема с закалки:", err);
      alert(`Ошибка: ${err.message}`);
    }
  };

  // Вставка поиска и счётчика в хедер
  useEffect(() => {
    setHeaderExtras(
      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
        <input
          type="text"
          placeholder="Поиск по номеру, названию..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="border border-gray-300 rounded-lg px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
          style={{ width: "220px" }}
        />
        <span className="text-sm text-gray-600">
          Рейсов: <strong>{trips.length}</strong>
        </span>
      </div>
    );
    return () => setHeaderExtras(null);
  }, [searchQuery, trips.length]);

  useEffect(() => {
    fetchTrips();
  }, []);

  const filteredTrips = trips.filter(trip => {
    const matchesFilter = tripFilter === 'all' || trip.status === tripFilter;
    if (!matchesFilter) return false;
    if (!searchQuery.trim()) return true;
    const q = searchQuery.toLowerCase();
    return (
      String(trip.tripNumber || "").toLowerCase().includes(q) ||
      String(trip.partner || "").toLowerCase().includes(q) ||
      String(trip.id || "").toLowerCase().includes(q)
    );
  });

  // Фильтруем детали по поисковому запросу
  const filteredTripDetails = tripDetails.filter(detail => {
    if (!tripDetailsSearch) return true;
    const searchLower = tripDetailsSearch.toLowerCase();
    return (
      detail.orderNumber.toString().includes(searchLower) ||
      detail.detailText.toLowerCase().includes(searchLower)
    );
  });

  // Группируем отфильтрованные детали по заказам
  const groupedTripDetails = {};
  filteredTripDetails.forEach((detail, index) => {
    // Находим оригинальный индекс в tripDetails
    const originalIndex = tripDetails.findIndex(d =>
      d.orderId === detail.orderId && d.detailId === detail.detailId
    );

    if (!groupedTripDetails[detail.orderId]) {
      groupedTripDetails[detail.orderId] = [];
    }
    groupedTripDetails[detail.orderId].push({ ...detail, originalIndex });
  });

  // Фильтруем доступные детали по поисковому запросу
  const filteredAvailableDetails = availableDetails.filter(detail => {
    if (!availableDetailsSearch) return true;
    const searchLower = availableDetailsSearch.toLowerCase();
    return (
      detail.orderNumber.toString().includes(searchLower) ||
      detail.detailText.toLowerCase().includes(searchLower)
    );
  });

  // Группируем отфильтрованные доступные детали по заказам
  const groupedAvailableDetails = {};
  filteredAvailableDetails.forEach((detail, index) => {
    // Находим оригинальный индекс в availableDetails
    const originalIndex = availableDetails.findIndex(d =>
      d.orderId === detail.orderId && d.detailId === detail.detailId
    );

    if (!groupedAvailableDetails[detail.orderId]) {
      groupedAvailableDetails[detail.orderId] = [];
    }
    groupedAvailableDetails[detail.orderId].push({ ...detail, originalIndex });
  });

  return (
    <div className="p-4 max-w-7xl mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-800 mb-2">Рейсы Закалка</h1>
        <p className="text-gray-600">Управление рейсами на закалку</p>
      </div>

      {/* Фильтры */}
      <div className="mb-6 bg-white rounded-lg shadow p-4">
        <div className="flex flex-wrap gap-2 items-center">
          <span className="text-sm font-medium text-gray-700">Фильтр:</span>
          {[
            { value: 'all', label: 'Все' },
            { value: 'saved', label: 'Сохранен' },
            { value: 'shipped', label: 'Принят водителем' },
            { value: 'delivered_to_partner', label: 'У партнера' },
            { value: 'received_from_partner', label: 'Забран' },
            { value: 'received', label: 'Принят с закалки' }
          ].map(filter => (
            <button
              key={filter.value}
              onClick={() => setTripFilter(filter.value)}
              className={`px-3 py-1.5 text-sm font-medium rounded-lg transition-colors ${
                tripFilter === filter.value
                  ? 'bg-blue-500 text-white'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              {filter.label}
            </button>
          ))}
        </div>
      </div>

      {/* Список рейсов */}
      {loadingTrips ? (
        <div className="text-center py-12">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
          <p className="mt-4 text-gray-600">Загрузка рейсов...</p>
        </div>
      ) : filteredTrips.length === 0 ? (
        <div className="text-center py-12 bg-white rounded-lg shadow">
          <p className="text-lg text-gray-500">📦</p>
          <p className="mt-2 text-gray-600">Рейсов не найдено</p>
          <p className="text-sm mt-1 text-gray-500">Создайте рейс на странице "Закалка Заказы"</p>
        </div>
      ) : (
        <div className="space-y-4">
          {filteredTrips.map(trip => {
            const statusConfig = {
              draft: { icon: '📝', label: 'Черновик', color: 'bg-gray-100 text-gray-800' },
              saved: { icon: '💾', label: 'Сохранен', color: 'bg-gray-100 text-gray-800' },
              shipped: { icon: '🚚', label: 'Принят водителем', color: 'bg-blue-100 text-blue-800' },
              delivered_to_partner: { icon: '🏭', label: 'У партнера', color: 'bg-yellow-100 text-yellow-800' },
              received_from_partner: { icon: '📦', label: 'Забран у партнера', color: 'bg-orange-100 text-orange-800' },
              received: { icon: '✅', label: 'Принят с закалки', color: 'bg-green-100 text-green-800' }
            };
            const status = statusConfig[trip.status] || statusConfig.saved;

            return (
              <div
                key={trip.id}
                className="bg-white border border-gray-200 rounded-lg p-4 hover:shadow-lg transition-shadow"
              >
                <div className="flex flex-col lg:flex-row lg:justify-between lg:items-start gap-4">
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-3">
                      <h3 className="text-lg font-semibold text-gray-800">
                        Рейс №{trip.tripNumber}
                      </h3>
                      <span className={`text-xs px-2 py-1 rounded-full ${status.color}`}>
                        {status.icon} {status.label}
                      </span>
                      <span className={`text-xs px-2 py-1 rounded-full ${
                        trip.type === 'shipping' ? 'bg-purple-100 text-purple-800' : 'bg-orange-100 text-orange-800'
                      }`}>
                        {trip.type === 'shipping' ? 'Отгрузка' : 'Прием'}
                      </span>
                    </div>
                    <div className="text-sm text-gray-600 space-y-1">
                      {trip.partner && <p className="font-medium text-purple-700">Партнер: {trip.partner}</p>}
                      <p>Создан: {new Date(trip.createdDate).toLocaleString('ru-RU')}</p>
                      {trip.shippedDate && <p>Принят водителем: {new Date(trip.shippedDate).toLocaleString('ru-RU')}</p>}
                      {trip.deliveredToPartnerDate && <p>Сдан партнеру: {new Date(trip.deliveredToPartnerDate).toLocaleString('ru-RU')}</p>}
                      {trip.receivedFromPartnerDate && <p>Забран у партнера: {new Date(trip.receivedFromPartnerDate).toLocaleString('ru-RU')}</p>}
                      {trip.receivedFromZakalkaDate && <p>Принят с закалки: {new Date(trip.receivedFromZakalkaDate).toLocaleString('ru-RU')}</p>}
                      <p className="font-medium">Заказов: {trip.totalOrders} | Деталей: {trip.totalDetails}</p>
                    </div>

                    {/* Блок статистики по недостачам */}
                    {trip.receivingStats && (trip.status === 'received_from_partner' || trip.status === 'received') && (
                      <div className="mt-3 p-3 rounded-lg border bg-gray-50">
                        <p className="text-xs font-semibold text-gray-700 mb-2">Состояние приёмки:</p>
                        <div className="grid grid-cols-3 gap-2 text-xs">
                          <div className="bg-green-50 border border-green-200 rounded-lg p-2 text-center">
                            <p className="text-green-700 font-medium">Отмечено</p>
                            <p className="text-lg font-bold text-green-600">
                              {trip.receivingStats.checkedDetails}
                              <span className="text-xs font-normal text-green-500"> / {trip.receivingStats.detailsCount} дет.</span>
                            </p>
                            <p className="text-green-600">{trip.receivingStats.checkedQuantity} шт</p>
                          </div>
                          <div className={`border rounded-lg p-2 text-center ${
                            trip.receivingStats.uncheckedDetails > 0
                              ? 'bg-red-50 border-red-200'
                              : 'bg-gray-50 border-gray-200'
                          }`}>
                            <p className={`font-medium ${trip.receivingStats.uncheckedDetails > 0 ? 'text-red-700' : 'text-gray-500'}`}>
                              Не отмечено
                            </p>
                            <p className={`text-lg font-bold ${trip.receivingStats.uncheckedDetails > 0 ? 'text-red-600' : 'text-gray-400'}`}>
                              {trip.receivingStats.uncheckedDetails}
                              <span className={`text-xs font-normal ${trip.receivingStats.uncheckedDetails > 0 ? 'text-red-400' : 'text-gray-400'}`}> дет.</span>
                            </p>
                            <p className={trip.receivingStats.uncheckedDetails > 0 ? 'text-red-600' : 'text-gray-400'}>
                              {trip.receivingStats.uncheckedQuantity} шт
                            </p>
                          </div>
                          <div className={`border rounded-lg p-2 text-center ${
                            trip.receivingStats.shortageDetails > 0
                              ? 'bg-orange-50 border-orange-200'
                              : 'bg-gray-50 border-gray-200'
                          }`}>
                            <p className={`font-medium ${trip.receivingStats.shortageDetails > 0 ? 'text-orange-700' : 'text-gray-500'}`}>
                              Недостача
                            </p>
                            <p className={`text-lg font-bold ${trip.receivingStats.shortageDetails > 0 ? 'text-orange-600' : 'text-gray-400'}`}>
                              {trip.receivingStats.shortageDetails}
                              <span className={`text-xs font-normal ${trip.receivingStats.shortageDetails > 0 ? 'text-orange-400' : 'text-gray-400'}`}> дет.</span>
                            </p>
                            <p className={trip.receivingStats.shortageDetails > 0 ? 'text-orange-600' : 'text-gray-400'}>
                              {trip.receivingStats.shortageQuantity} шт
                            </p>
                          </div>
                        </div>
                        {/* Прогресс-бар */}
                        {trip.receivingStats.detailsCount > 0 && (
                          <div className="mt-2">
                            <div className="w-full bg-gray-200 rounded-full h-2">
                              <div
                                className={`h-2 rounded-full transition-all ${
                                  trip.receivingStats.checkedDetails === trip.receivingStats.detailsCount
                                    ? 'bg-green-500'
                                    : trip.receivingStats.checkedDetails > 0
                                      ? 'bg-blue-500'
                                      : 'bg-gray-300'
                                }`}
                                style={{ width: `${(trip.receivingStats.checkedDetails / trip.receivingStats.detailsCount) * 100}%` }}
                              ></div>
                            </div>
                            <p className="text-xs text-gray-500 mt-1 text-center">
                              Прогресс приёмки: {Math.round((trip.receivingStats.checkedDetails / trip.receivingStats.detailsCount) * 100)}%
                            </p>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                  <div className="flex flex-wrap gap-2">
                    <button
                      onClick={() => handleViewTrip(trip)}
                      className="px-4 py-2 text-sm bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
                    >
                      👁️ Просмотр
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Модальное окно просмотра */}
      {showViewTripModal && viewingTrip && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-[9999] flex items-center justify-center p-4">
          <div className="bg-white rounded-lg max-w-5xl w-full max-h-[95vh] overflow-hidden flex flex-col shadow-2xl">
            {/* Заголовок */}
            <div className="flex items-center justify-between px-4 py-2 border-b bg-gray-50">
              <h2 className="text-lg font-semibold">
                Рейс №{viewingTrip.tripNumber}
              </h2>
              <button
                onClick={() => {
                  setShowViewTripModal(false);
                  setViewingTrip(null);
                  setViewTripInfoExpanded(false);
                  setTripShortages([]);
                  setViewTripPhotos([]);
                }}
                className="text-gray-500 hover:text-gray-700 text-2xl w-8 h-8"
              >
                ✕
              </button>
            </div>

            {/* Содержимое */}
            <div className="flex-1 overflow-hidden p-3 flex flex-col">
              {loadingTripDetails.has(viewingTrip.id) ? (
                <div className="flex-1 flex items-center justify-center">
                  <div className="text-center">
                    <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-blue-600 border-r-transparent"></div>
                    <p className="mt-2 text-gray-600 text-sm">Загрузка деталей...</p>
                  </div>
                </div>
              ) : tripDetailsData[viewingTrip.id] && tripDetailsData[viewingTrip.id].length > 0 ? (
                <>
                  {/* Информация о рейсе - компактный блок */}
                  <div className="bg-blue-50 border border-blue-200 rounded-lg p-2 mb-2 flex-shrink-0">
                    {(() => {
                      const statusConfig = {
                        saved: { icon: '💾', label: 'Сохранен', color: 'bg-gray-100 text-gray-800' },
                        shipped: { icon: '🚚', label: 'Принят водителем', color: 'bg-blue-100 text-blue-800' },
                        delivered_to_partner: { icon: '🏭', label: 'У партнера', color: 'bg-yellow-100 text-yellow-800' },
                        received_from_partner: { icon: '📦', label: 'Забран у партнера', color: 'bg-orange-100 text-orange-800' },
                        received: { icon: '✅', label: 'Принят с закалки', color: 'bg-green-100 text-green-800' }
                      };
                      const status = statusConfig[viewingTrip.status] || statusConfig.saved;
                      const isReceiving = (viewingTrip.status === 'received_from_partner' || viewingTrip.status === 'received') && viewingTrip.receivingStats;
                      const details = tripDetailsData[viewingTrip.id];
                      let totalQuantity = 0;
                      let totalArea = 0;
                      const thicknessStats = {};

                      details.forEach(detail => {
                        const detailText = detail.detail_text || detail.detailText;
                        const glassType = detail.glass_type || detail.glassType;
                        const quantity = detail.quantity || 1;
                        let thickness = 'Неизвестная толщина';
                        if (glassType) {
                          const m = glassType.match(/(\d+)\s*мм/);
                          if (m) thickness = `${m[1]}мм`;
                        } else if (detailText) {
                          const m = detailText.match(/(\d+)\s*мм/);
                          if (m) thickness = `${m[1]}мм`;
                        }
                        let area = 0;
                        if (detailText) {
                          const sizeMatch = detailText.match(/(\d+)\s*[xх×*]\s*(\d+)/i);
                          if (sizeMatch) area = (parseInt(sizeMatch[1]) * parseInt(sizeMatch[2]) * quantity) / 1000000;
                        }
                        if (!thicknessStats[thickness]) thicknessStats[thickness] = { quantity: 0, area: 0 };
                        thicknessStats[thickness].quantity += quantity;
                        thicknessStats[thickness].area += area;
                        totalQuantity += quantity;
                        totalArea += area;
                      });

                      return (
                        <>
                          {/* Компактная сводка - всегда видна */}
                          <div className="flex items-center gap-2 flex-wrap text-xs">
                            <span className={`inline-block px-2 py-0.5 rounded-full ${status.color}`}>
                              {status.icon} {status.label}
                            </span>
                            <span className="text-purple-700 font-medium">{viewingTrip.partner || 'Не указан'}</span>
                            <span className="text-gray-400">|</span>
                            <span className="text-gray-700">{viewingTrip.totalOrders} зак.</span>
                            <span className="text-gray-700 font-semibold">{totalQuantity} шт</span>
                            <span className="text-gray-700">{totalArea.toFixed(2)} м²</span>
                            <span className="text-gray-400">|</span>
                            <span className="text-gray-600">
                              {Object.entries(thicknessStats).map(([t, s], i) => (
                                <span key={t}>{i > 0 ? ', ' : ''}<span className="font-medium">{t}</span>:{s.quantity}шт</span>
                              ))}
                            </span>
                            {isReceiving && (
                              <>
                                <span className="text-gray-400">|</span>
                                <span className="text-green-600 font-medium">{viewingTrip.receivingStats.checkedDetails}/{viewingTrip.receivingStats.detailsCount}</span>
                                {viewingTrip.receivingStats.uncheckedDetails > 0 && (
                                  <span className="text-red-600 font-medium">-{viewingTrip.receivingStats.uncheckedDetails}</span>
                                )}
                                {viewingTrip.receivingStats.shortageDetails > 0 && (
                                  <span className="text-orange-600 font-medium">!{viewingTrip.receivingStats.shortageDetails}</span>
                                )}
                                {viewingTrip.receivingStats.detailsCount > 0 && (
                                  <div className="flex items-center gap-1 flex-shrink-0" style={{minWidth: '80px'}}>
                                    <div className="w-16 bg-gray-200 rounded-full h-1.5">
                                      <div
                                        className={`h-1.5 rounded-full ${
                                          viewingTrip.receivingStats.checkedDetails === viewingTrip.receivingStats.detailsCount
                                            ? 'bg-green-500' : viewingTrip.receivingStats.checkedDetails > 0 ? 'bg-blue-500' : 'bg-gray-300'
                                        }`}
                                        style={{ width: `${(viewingTrip.receivingStats.checkedDetails / viewingTrip.receivingStats.detailsCount) * 100}%` }}
                                      ></div>
                                    </div>
                                    <span className="text-gray-500">{Math.round((viewingTrip.receivingStats.checkedDetails / viewingTrip.receivingStats.detailsCount) * 100)}%</span>
                                  </div>
                                )}
                              </>
                            )}
                            <button
                              onClick={() => setViewTripInfoExpanded(!viewTripInfoExpanded)}
                              className="ml-auto text-blue-600 hover:text-blue-800 text-xs font-medium flex-shrink-0"
                            >
                              {viewTripInfoExpanded ? 'Свернуть ▲' : 'Подробнее ▼'}
                            </button>
                          </div>

                          {/* Развернутая информация */}
                          {viewTripInfoExpanded && (
                            <div className="mt-2 pt-2 border-t border-blue-300">
                              <div className="grid grid-cols-4 gap-x-3 gap-y-1 text-xs mb-2">
                                <div>
                                  <span className="text-gray-500">Тип:</span> <span className="font-medium">{viewingTrip.type === 'shipping' ? 'Отгрузка' : 'Прием'}</span>
                                </div>
                                <div>
                                  <span className="text-gray-500">Создан:</span> <span className="font-medium">{new Date(viewingTrip.createdDate).toLocaleString('ru-RU')}</span>
                                </div>
                                {viewingTrip.shippedDate && (
                                  <div>
                                    <span className="text-gray-500">Принят вод.:</span> <span className="font-medium">{new Date(viewingTrip.shippedDate).toLocaleString('ru-RU')}</span>
                                  </div>
                                )}
                                {viewingTrip.deliveredToPartnerDate && (
                                  <div>
                                    <span className="text-gray-500">Сдан партн.:</span> <span className="font-medium">{new Date(viewingTrip.deliveredToPartnerDate).toLocaleString('ru-RU')}</span>
                                  </div>
                                )}
                                {viewingTrip.receivedFromPartnerDate && (
                                  <div>
                                    <span className="text-gray-500">Забран:</span> <span className="font-medium">{new Date(viewingTrip.receivedFromPartnerDate).toLocaleString('ru-RU')}</span>
                                  </div>
                                )}
                                {viewingTrip.receivedFromZakalkaDate && (
                                  <div>
                                    <span className="text-gray-500">Принят:</span> <span className="font-medium">{new Date(viewingTrip.receivedFromZakalkaDate).toLocaleString('ru-RU')}</span>
                                  </div>
                                )}
                              </div>
                              <div className="grid grid-cols-4 gap-2 text-xs">
                                <div>
                                  <span className="text-gray-500">Кол-во:</span> <span className="font-bold text-blue-900">{totalQuantity} шт</span>
                                </div>
                                <div>
                                  <span className="text-gray-500">Площадь:</span> <span className="font-bold text-blue-900">{totalArea.toFixed(2)} м²</span>
                                </div>
                                <div className="col-span-2">
                                  <span className="text-gray-500">По толщине:</span>{' '}
                                  {Object.entries(thicknessStats).map(([thickness, stats]) => (
                                    <span key={thickness} className="text-gray-700 mr-2">
                                      <span className="font-medium">{thickness}:</span> {stats.quantity}шт, {stats.area.toFixed(2)}м²
                                    </span>
                                  ))}
                                </div>
                              </div>

                              {/* Развернутая статистика по приёмке */}
                              {isReceiving && (
                                <div className="mt-2 pt-2 border-t border-blue-300">
                                  <div className="grid grid-cols-3 gap-2">
                                    <div className="bg-green-50 border border-green-200 rounded p-1.5 text-center">
                                      <p className="text-xs text-green-700 font-medium">Отмечено</p>
                                      <p className="text-sm font-bold text-green-600">
                                        {viewingTrip.receivingStats.checkedDetails}
                                        <span className="text-xs font-normal"> / {viewingTrip.receivingStats.detailsCount}</span>
                                      </p>
                                      <p className="text-xs text-green-600">{viewingTrip.receivingStats.checkedQuantity} шт</p>
                                    </div>
                                    <div className={`border rounded p-1.5 text-center ${
                                      viewingTrip.receivingStats.uncheckedDetails > 0 ? 'bg-red-50 border-red-200' : 'bg-gray-50 border-gray-200'
                                    }`}>
                                      <p className={`text-xs font-medium ${viewingTrip.receivingStats.uncheckedDetails > 0 ? 'text-red-700' : 'text-gray-500'}`}>Не отмечено</p>
                                      <p className={`text-sm font-bold ${viewingTrip.receivingStats.uncheckedDetails > 0 ? 'text-red-600' : 'text-gray-400'}`}>
                                        {viewingTrip.receivingStats.uncheckedDetails}
                                      </p>
                                      <p className={`text-xs ${viewingTrip.receivingStats.uncheckedDetails > 0 ? 'text-red-600' : 'text-gray-400'}`}>
                                        {viewingTrip.receivingStats.uncheckedQuantity} шт
                                      </p>
                                    </div>
                                    <div className={`border rounded p-1.5 text-center ${
                                      viewingTrip.receivingStats.shortageDetails > 0 ? 'bg-orange-50 border-orange-200' : 'bg-gray-50 border-gray-200'
                                    }`}>
                                      <p className={`text-xs font-medium ${viewingTrip.receivingStats.shortageDetails > 0 ? 'text-orange-700' : 'text-gray-500'}`}>Недостача</p>
                                      <p className={`text-sm font-bold ${viewingTrip.receivingStats.shortageDetails > 0 ? 'text-orange-600' : 'text-gray-400'}`}>
                                        {viewingTrip.receivingStats.shortageDetails}
                                      </p>
                                      <p className={`text-xs ${viewingTrip.receivingStats.shortageDetails > 0 ? 'text-orange-600' : 'text-gray-400'}`}>
                                        {viewingTrip.receivingStats.shortageQuantity} шт
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          )}
                        </>
                      );
                    })()}
                  </div>

                  {/* Список деталей */}
                  <div className="flex-1 flex flex-col min-h-0 border border-gray-200 rounded-lg overflow-hidden bg-white">
                    <div className="flex-shrink-0 p-2 border-b border-gray-200 bg-gray-50">
                      <h3 className="font-semibold text-sm mb-1.5">Детали рейса</h3>
                      <input
                        type="text"
                        placeholder="Поиск по заказу, размерам или типу стекла..."
                        value={viewTripDetailsSearch}
                        onChange={(e) => setViewTripDetailsSearch(e.target.value)}
                        className="w-full px-2 py-1.5 border border-gray-300 rounded text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                    </div>

                    <div className="flex-1 overflow-y-auto">
                      {(() => {
                        const details = tripDetailsData[viewingTrip.id];
                        const searchLower = viewTripDetailsSearch.toLowerCase();
                        const filteredDetails = details.filter(detail => {
                          const detailText = (detail.detail_text || detail.detailText || '').toLowerCase();
                          const glassType = (detail.glass_type || detail.glassType || '').toLowerCase();
                          const orderNumber = (detail.order_number || detail.orderNumber || '').toLowerCase();
                          return orderNumber.includes(searchLower) ||
                                 detailText.includes(searchLower) ||
                                 glassType.includes(searchLower);
                        });

                        const isReceivingTrip = viewingTrip.status === 'received_from_partner' || viewingTrip.status === 'received';
                        const isReceivedTrip = viewingTrip.status === 'received';

                        // Создаём map недостач по detail_id+order_id для быстрого поиска
                        const shortageMap = new Map();
                        if (tripShortages.length > 0) {
                          tripShortages.forEach(s => {
                            shortageMap.set(`${s.orderId}_${s.detailId}`, s);
                          });
                        }

                        return (
                          <table className="w-full text-sm">
                            <thead className="bg-gray-100 border-b border-gray-200 sticky top-0">
                              <tr>
                                <th className="px-3 py-2 text-left font-semibold text-gray-700">Заказ</th>
                                <th className="px-3 py-2 text-left font-semibold text-gray-700">Размеры</th>
                                <th className="px-3 py-2 text-left font-semibold text-gray-700">Тип стекла</th>
                                <th className="px-3 py-2 text-center font-semibold text-gray-700">Кол-во</th>
                                {isReceivingTrip && (
                                  <th className="px-3 py-2 text-center font-semibold text-gray-700">Принято</th>
                                )}
                                {isReceivedTrip && tripShortages.length > 0 && (
                                  <th className="px-3 py-2 text-center font-semibold text-gray-700">Статус</th>
                                )}
                              </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-200">
                              {filteredDetails.length > 0 ? (
                                filteredDetails.map((detail, idx) => {
                                  const detailText = detail.detail_text || detail.detailText;
                                  const glassType = detail.glass_type || detail.glassType;
                                  const quantity = detail.quantity;
                                  const orderNumber = detail.order_number || detail.orderNumber;
                                  const orderId = detail.order_id || detail.orderId;
                                  const detailId = detail.detail_id || detail.detailId;
                                  const receivedQty = detail.received_quantity;
                                  const hasShortage = isReceivingTrip && receivedQty !== null && receivedQty !== undefined && receivedQty < quantity;
                                  const isUnchecked = isReceivingTrip && (receivedQty === null || receivedQty === undefined || receivedQty === 0);

                                  // Поиск недостачи для этой детали
                                  const shortage = shortageMap.get(`${orderId}_${detailId}`);

                                  return (
                                    <tr key={idx} className={`hover:bg-gray-50 ${
                                      isUnchecked ? 'bg-red-50' : hasShortage ? 'bg-orange-50' : ''
                                    }`}>
                                      <td className="px-3 py-2 font-medium text-gray-900">{orderNumber}</td>
                                      <td className="px-3 py-2 text-gray-700">{detailText}</td>
                                      <td className="px-3 py-2">
                                        {glassType ? (
                                          <span className="inline-block px-2 py-0.5 bg-purple-100 text-purple-700 rounded text-xs">
                                            {glassType}
                                          </span>
                                        ) : (
                                          <span className="text-gray-400 text-xs">—</span>
                                        )}
                                      </td>
                                      <td className="px-3 py-2 text-center">
                                        <span className="inline-block px-2 py-1 bg-blue-100 text-blue-800 rounded text-xs font-medium">
                                          {quantity} шт
                                        </span>
                                      </td>
                                      {isReceivingTrip && (
                                        <td className="px-3 py-2 text-center">
                                          {receivedQty !== null && receivedQty !== undefined ? (
                                            <span className={`inline-block px-2 py-1 rounded text-xs font-medium ${
                                              receivedQty === 0
                                                ? 'bg-red-100 text-red-700'
                                                : receivedQty < quantity
                                                  ? 'bg-orange-100 text-orange-700'
                                                  : 'bg-green-100 text-green-700'
                                            }`}>
                                              {receivedQty === 0 ? 'Нет' : `${receivedQty} шт`}
                                              {hasShortage && receivedQty > 0 && (
                                                <span className="ml-1 text-red-600">(-{quantity - receivedQty})</span>
                                              )}
                                            </span>
                                          ) : (
                                            <span className="inline-block px-2 py-1 bg-gray-100 text-gray-500 rounded text-xs">
                                              —
                                            </span>
                                          )}
                                        </td>
                                      )}
                                      {isReceivedTrip && tripShortages.length > 0 && (
                                        <td className="px-3 py-2 text-center">
                                          {shortage ? (
                                            <span className={`inline-block px-2 py-0.5 rounded text-xs font-medium ${
                                              shortage.status === 'resolved'
                                                ? 'bg-green-100 text-green-700'
                                                : shortage.status === 'reprocess'
                                                  ? 'bg-orange-100 text-orange-700'
                                                  : 'bg-red-100 text-red-700'
                                            }`}>
                                              {shortage.status === 'resolved' ? 'Нашлось' :
                                               shortage.status === 'reprocess' ? 'Переделка' : 'Не решено'}
                                            </span>
                                          ) : (
                                            <span className="inline-block px-2 py-0.5 bg-green-100 text-green-700 rounded text-xs font-medium">OK</span>
                                          )}
                                        </td>
                                      )}
                                    </tr>
                                  );
                                })
                              ) : (
                                <tr>
                                  <td colSpan={isReceivingTrip ? (isReceivedTrip && tripShortages.length > 0 ? 6 : 5) : 4} className="px-3 py-8 text-center text-gray-500">
                                    Детали не найдены
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        );
                      })()}
                    </div>
                  </div>

                  {/* Блок фото водителя */}
                  {(loadingViewTripPhotos || viewTripPhotos.length > 0) && (
                    <div className="mt-2 flex-shrink-0 border border-gray-200 rounded-lg overflow-hidden bg-gray-50">
                      <div className="px-3 py-2 bg-gray-100 border-b border-gray-200">
                        <h3 className="font-semibold text-sm text-gray-800">
                          Фото водителя {viewTripPhotos.length > 0 && `(${viewTripPhotos.length})`}
                        </h3>
                      </div>
                      <div className="p-2">
                        {loadingViewTripPhotos ? (
                          <p className="text-xs text-gray-500">Загрузка фото...</p>
                        ) : (
                          <div className="flex flex-wrap gap-2">
                            {viewTripPhotos.map((photo, index) => {
                              const photoUrl = typeof photo === 'string' ? photo : (photo.url || photo.file_path);
                              return (
                                <img
                                  key={photo.id || index}
                                  src={`${API_URL}${photoUrl}`}
                                  alt={`Фото ${index + 1}`}
                                  className="w-24 h-24 object-cover rounded border border-gray-300 cursor-pointer hover:opacity-80 transition-opacity"
                                  onClick={() => window.open(`${API_URL}${photoUrl}`, '_blank')}
                                />
                              );
                            })}
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Блок недостач */}
                  {viewingTrip.status === 'received' && tripShortages.length > 0 && (
                    <div className="mt-2 flex-shrink-0 border border-orange-300 rounded-lg overflow-hidden bg-orange-50">
                      <div className="px-3 py-2 bg-orange-100 border-b border-orange-300">
                        <h3 className="font-semibold text-sm text-orange-800">
                          Недостачи ({tripShortages.length} поз.
                          {tripShortages.filter(s => s.status === 'pending').length > 0 &&
                            `, ${tripShortages.filter(s => s.status === 'pending').length} не решено`
                          })
                        </h3>
                      </div>
                      <div className="max-h-48 overflow-y-auto divide-y divide-orange-200">
                        {tripShortages.map(shortage => (
                          <div key={shortage.id} className={`px-3 py-2 ${
                            shortage.status === 'resolved' ? 'bg-green-50' :
                            shortage.status === 'reprocess' ? 'bg-orange-50' : 'bg-white'
                          }`}>
                            <div className="flex items-center justify-between gap-2">
                              <div className="flex-1 min-w-0">
                                <div className="flex items-center gap-2 flex-wrap">
                                  <span className="font-medium text-sm text-gray-900">{shortage.orderNumber}</span>
                                  <span className="text-gray-400">|</span>
                                  <span className="text-sm text-gray-700 truncate">{shortage.detailText}</span>
                                </div>
                                <div className="flex items-center gap-2 mt-0.5">
                                  <span className="text-xs text-gray-500">Отпр: {shortage.sentQuantity}</span>
                                  <span className="text-xs text-gray-500">Пол: {shortage.receivedQuantity}</span>
                                  <span className="text-xs font-medium text-red-600">Недостача: {shortage.shortageQuantity} шт</span>
                                </div>
                                {shortage.status === 'reprocess' && shortage.resolutionNotes && (
                                  <div className="text-xs text-orange-700 mt-0.5">
                                    Причина: {shortage.resolutionNotes}
                                  </div>
                                )}
                              </div>
                              <div className="flex items-center gap-1 flex-shrink-0">
                                {shortage.status === 'pending' ? (
                                  <>
                                    <button
                                      onClick={() => handleResolveShortage(shortage.id, 'found')}
                                      disabled={resolvingShortageId === shortage.id}
                                      className="px-2 py-1 text-xs bg-green-500 text-white rounded hover:bg-green-600 transition-colors disabled:opacity-50"
                                    >
                                      {resolvingShortageId === shortage.id ? '...' : 'Нашлось'}
                                    </button>
                                    <button
                                      onClick={() => openReworkModal(shortage)}
                                      disabled={resolvingShortageId === shortage.id}
                                      className="px-2 py-1 text-xs bg-orange-500 text-white rounded hover:bg-orange-600 transition-colors disabled:opacity-50"
                                    >
                                      В переделку
                                    </button>
                                  </>
                                ) : (
                                  <span className={`px-2 py-1 rounded text-xs font-medium text-right ${
                                    shortage.status === 'resolved'
                                      ? 'bg-green-100 text-green-700'
                                      : 'bg-orange-100 text-orange-700'
                                  }`}>
                                    <span className="block">
                                      {shortage.status === 'resolved' ? 'Нашлось' : 'Ушёл на переделку'}
                                    </span>
                                    {shortage.status === 'reprocess' && shortage.resolvedAt && (
                                      <span className="block text-[10px] font-normal opacity-80">
                                        {new Date(shortage.resolvedAt).toLocaleString('ru-RU')}
                                      </span>
                                    )}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </>
              ) : (
                <div className="flex-1 flex items-center justify-center">
                  <div className="text-center text-gray-500">
                    Нет деталей
                  </div>
                </div>
              )}
            </div>

            {/* Футер с кнопками действий */}
            <div className="border-t px-4 py-2 bg-gray-50">
              <div className="flex flex-wrap gap-2 items-center">
                {/* Кнопки для статуса "saved" */}
                {viewingTrip.status === 'saved' && (
                  <button
                    onClick={async () => {
                      await handleAcceptByDriver(viewingTrip.id);
                      setShowViewTripModal(false);
                      setViewingTrip(null);
                      setViewTripInfoExpanded(false);
                    }}
                    className="px-3 py-2 text-sm bg-green-500 text-white rounded hover:bg-green-600 transition-colors"
                  >
                    🚚 Принять водителем
                  </button>
                )}

                {/* Кнопка для статуса "shipped" */}
                {viewingTrip.status === 'shipped' && (
                  <button
                    onClick={async () => {
                      await handleDeliverToPartner(viewingTrip.id);
                      setShowViewTripModal(false);
                      setViewingTrip(null);
                      setViewTripInfoExpanded(false);
                    }}
                    className="px-3 py-2 text-sm bg-yellow-500 text-white rounded hover:bg-yellow-600 transition-colors"
                  >
                    🏭 Сдать партнеру
                  </button>
                )}

                {/* Кнопка для статуса "delivered_to_partner" */}
                {viewingTrip.status === 'delivered_to_partner' && (
                  <button
                    onClick={async () => {
                      await handleReceiveFromPartner(viewingTrip.id);
                      setShowViewTripModal(false);
                      setViewingTrip(null);
                      setViewTripInfoExpanded(false);
                    }}
                    className="px-3 py-2 text-sm bg-orange-500 text-white rounded hover:bg-orange-600 transition-colors"
                  >
                    📦 Забрать у партнера
                  </button>
                )}

                {/* Кнопка для статуса "received_from_partner" */}
                {viewingTrip.status === 'received_from_partner' && (
                  <button
                    onClick={async () => {
                      await handleReceiveFromZakalka(viewingTrip.id);
                    }}
                    className="px-3 py-2 text-sm bg-green-500 text-white rounded hover:bg-green-600 transition-colors"
                  >
                    ✅ Принять с закалки
                  </button>
                )}

                {/* Кнопка генерации партнерского PDF */}
                <button
                  onClick={handleGenerateViewPartnerPDF}
                  disabled={generatingViewPartnerPDF || loadingTripDetails.has(viewingTrip.id) || !tripDetailsData[viewingTrip.id] || tripDetailsData[viewingTrip.id].length === 0}
                  className="px-3 py-2 text-sm bg-purple-500 text-white rounded hover:bg-purple-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                  title="Сгенерировать отчет партнера"
                >
                  {generatingViewPartnerPDF ? '⏳ Генерация...' : '📄 Отчет партнера'}
                </button>

                {/* Кнопки Редактировать и Удалить */}
                <button
                  onClick={() => {
                    setShowViewTripModal(false);
                    setViewingTrip(null);
                    setViewTripInfoExpanded(false);
                    handleEditTrip(viewingTrip);
                  }}
                  className="px-3 py-2 text-sm bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
                >
                  ✏️ Редактировать детали
                </button>
                <button
                  onClick={async () => {
                    await handleDeleteTrip(viewingTrip.id);
                    setShowViewTripModal(false);
                    setViewingTrip(null);
                    setViewTripInfoExpanded(false);
                  }}
                  className="px-3 py-2 text-sm bg-red-500 text-white rounded hover:bg-red-600 transition-colors"
                >
                  🗑️ Удалить
                </button>

                {/* Кнопка закрыть */}
                <button
                  onClick={() => {
                    setShowViewTripModal(false);
                    setViewingTrip(null);
                    setViewTripInfoExpanded(false);
                    setTripShortages([]);
                  }}
                  className="ml-auto px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded text-sm font-medium"
                >
                  Закрыть
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Модальное окно причины переделки */}
      {showReworkModal && reworkShortage && (
        <div className="fixed inset-0 bg-black bg-opacity-60 z-[10000] flex items-center justify-center p-4">
          <div className="bg-white rounded-lg max-w-md w-full shadow-2xl">
            <div className="flex items-center justify-between px-4 py-3 border-b bg-orange-50">
              <h3 className="text-base font-semibold text-orange-900">
                Отправка в переделку
              </h3>
              <button
                onClick={closeReworkModal}
                disabled={submittingRework}
                className="text-gray-500 hover:text-gray-700 text-xl w-7 h-7 disabled:opacity-50"
              >
                ✕
              </button>
            </div>

            <div className="p-4">
              <div className="mb-3 text-sm">
                <div className="font-medium text-gray-900">{reworkShortage.orderNumber}</div>
                <div className="text-gray-700">{reworkShortage.detailText}</div>
                <div className="text-xs text-red-600 mt-0.5">
                  Недостача: {reworkShortage.shortageQuantity} шт
                </div>
              </div>

              <label className="block text-sm font-medium text-gray-700 mb-1">
                Причина переделки <span className="text-red-500">*</span>
              </label>
              <textarea
                value={reworkReason}
                onChange={(e) => setReworkReason(e.target.value)}
                placeholder="Опишите причину переделки детали..."
                rows={4}
                autoFocus
                className="w-full px-3 py-2 border border-gray-300 rounded text-sm focus:outline-none focus:ring-2 focus:ring-orange-500 resize-none"
              />
            </div>

            <div className="flex items-center justify-end gap-2 px-4 py-3 border-t bg-gray-50">
              <button
                onClick={closeReworkModal}
                disabled={submittingRework}
                className="px-3 py-2 text-sm bg-gray-200 hover:bg-gray-300 rounded transition-colors disabled:opacity-50"
              >
                Отмена
              </button>
              <button
                onClick={handleSubmitRework}
                disabled={!reworkReason.trim() || submittingRework}
                className="px-3 py-2 text-sm bg-orange-500 text-white rounded hover:bg-orange-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {submittingRework ? '⏳ Отправка...' : 'Сохранить и отправить в переделку'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Модальное окно редактирования рейса */}
      {showTripModal && editingTrip && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-[9999] flex items-center justify-center p-4">
          <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-hidden flex flex-col shadow-2xl">
            {/* Заголовок */}
            <div className="flex items-center justify-between p-4 border-b">
              <h2 className="text-lg font-semibold">
                Редактирование рейса
              </h2>
              <button
                onClick={() => {
                  setShowTripModal(false);
                  setEditingTrip(null);
                  setLoadingTripDetailsInModal(false);
                  setLoadingAvailableDetailsInModal(false);
                }}
                className="text-gray-500 hover:text-gray-700"
              >
                ✕
              </button>
            </div>

            {/* Содержимое */}
            <div className="flex-1 overflow-y-auto p-4">
              {/* Информация о рейсе */}
              <div className="mb-4">
                <div className="grid grid-cols-1 gap-4 text-sm mb-4">
                  <div>
                    <span className="font-medium">Тип рейса:</span>{' '}
                    <span className={`px-2 py-1 rounded text-xs ${
                      editingTrip.type === 'shipping'
                        ? 'bg-purple-100 text-purple-800'
                        : 'bg-orange-100 text-orange-800'
                    }`}>
                      {editingTrip.type === 'shipping' ? 'Отгрузка' : 'Прием'}
                    </span>
                  </div>
                </div>

                {/* Выбор партнера закалки */}
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Партнер закалки
                  </label>
                  <select
                    value={tripPartner}
                    onChange={(e) => setTripPartner(e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="Казстековид">Казстековид</option>
                    <option value="Премиумгласс">Премиумгласс</option>
                    <option value="Руслан">Руслан</option>
                  </select>
                </div>

                {/* Редактирование статуса */}
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Статус рейса
                  </label>
                  <select
                    value={editingTrip.status}
                    onChange={(e) => setEditingTrip({...editingTrip, status: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="saved">💾 Сохранен</option>
                    <option value="shipped">🚚 Принят водителем</option>
                    <option value="delivered_to_partner">🏭 У партнера</option>
                    <option value="received_from_partner">📦 Забран у партнера</option>
                    <option value="received">✅ Принят с закалки</option>
                  </select>
                </div>

                {/* Редактирование примечаний */}
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Примечания (необязательно)
                  </label>
                  <textarea
                    value={editingTrip?.notes || ''}
                    onChange={(e) => setEditingTrip({...editingTrip, notes: e.target.value})}
                    placeholder="Введите примечания к рейсу"
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                    rows="2"
                  />
                </div>
              </div>

              {/* ФРЕЙМ 1: Детали в рейсе */}
              <div className="mb-6">
                <h3 className="text-sm font-semibold text-gray-700 mb-2">Детали в рейсе:</h3>

                {/* Поиск и кнопки управления деталями в рейсе */}
                <div className="mb-2 space-y-2">
                  <div className="flex gap-2">
                    <input
                      type="text"
                      value={tripDetailsSearch}
                      onChange={(e) => setTripDetailsSearch(e.target.value)}
                      placeholder="Поиск по номеру заказа или детали..."
                      className="flex-1 px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                    <button
                      onClick={() => {
                        setTripDetails(tripDetails.map(d => ({ ...d, isSelected: true })));
                      }}
                      className="px-3 py-2 bg-green-500 text-white rounded-lg text-sm hover:bg-green-600 whitespace-nowrap"
                    >
                      Выбрать все
                    </button>
                    <button
                      onClick={() => {
                        if (window.confirm('Снять выбор со всех деталей?')) {
                          setTripDetails(tripDetails.map(d => ({ ...d, isSelected: false })));
                        }
                      }}
                      className="px-3 py-2 bg-red-500 text-white rounded-lg text-sm hover:bg-red-600 whitespace-nowrap"
                    >
                      Очистить все
                    </button>
                  </div>
                </div>

                {/* Список деталей в рейсе */}
                <div className="border-2 border-blue-300 rounded-lg p-3 bg-blue-50 max-h-96 overflow-y-auto">
                  {loadingTripDetailsInModal ? (
                    <div className="flex flex-col items-center justify-center py-12">
                      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mb-4"></div>
                      <p className="text-gray-600 text-sm">Загрузка деталей рейса...</p>
                    </div>
                  ) : Object.entries(groupedTripDetails).length > 0 ? (
                    <div className="space-y-4">
                      {Object.entries(groupedTripDetails).map(([orderId, details]) => (
                        <div key={orderId} className="border border-gray-200 rounded-lg p-3 bg-white">
                          <h4 className="text-xs font-semibold text-gray-800 mb-2">
                            Заказ №{details[0].orderNumber}
                          </h4>
                          <div className="space-y-2">
                            {details.map((detail) => (
                              <div
                                key={detail.originalIndex}
                                className={`flex items-center justify-between p-2 rounded text-xs ${
                                  detail.isSelected
                                    ? 'bg-blue-50 border border-blue-200'
                                    : 'bg-gray-50 border border-gray-200'
                                }`}
                              >
                                <div className="flex items-center gap-2 flex-1">
                                  <input
                                    type="checkbox"
                                    checked={detail.isSelected}
                                    onChange={() => handleTripDetailToggle(detail.originalIndex)}
                                    className="w-4 h-4 text-blue-600 rounded focus:ring-2 focus:ring-blue-500 cursor-pointer"
                                  />
                                  <div className="flex-1">
                                    <p className="text-gray-800">{detail.detailText}</p>
                                    {detail.glassType && (
                                      <span className="inline-block px-2 py-0.5 bg-purple-100 text-purple-700 rounded text-xs mt-1 mr-2">
                                        {detail.glassType}
                                      </span>
                                    )}
                                    <p className="text-gray-500 text-xs mt-1">
                                      Макс. количество: {detail.maxQuantity} шт
                                    </p>
                                  </div>
                                </div>
                                <div className="flex items-center gap-2 ml-4">
                                  <button
                                    onClick={() => handleTripDetailQuantityChange(detail.originalIndex, detail.quantity - 1)}
                                    disabled={detail.quantity <= 1}
                                    className="w-6 h-6 rounded bg-red-100 hover:bg-red-200 text-red-600 text-xs font-bold disabled:opacity-50"
                                  >
                                    −
                                  </button>
                                  <span className="min-w-[2rem] text-center font-medium">
                                    {detail.quantity}
                                  </span>
                                  <button
                                    onClick={() => handleTripDetailQuantityChange(detail.originalIndex, detail.quantity + 1)}
                                    disabled={detail.quantity >= detail.maxQuantity}
                                    className="w-6 h-6 rounded bg-green-100 hover:bg-green-200 text-green-600 text-xs font-bold disabled:opacity-50"
                                  >
                                    +
                                  </button>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <>
                      {filteredTripDetails.length === 0 && (
                        <div className="text-center py-8 text-gray-500">
                          <p>
                            {tripDetailsSearch
                              ? 'Ничего не найдено по запросу'
                              : 'Нет деталей в рейсе'}
                          </p>
                        </div>
                      )}

                      {filteredTripDetails.length > 0 && tripDetails.filter(d => d.isSelected).length === 0 && (
                        <div className="text-center py-4 text-amber-600 bg-amber-50 rounded-lg">
                          <p>Выберите детали для рейса, поставив галочку</p>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>

              {/* ФРЕЙМ 2: Доступные детали для добавления */}
              <div>
                <h3 className="text-sm font-semibold text-gray-700 mb-2">Доступные детали для добавления:</h3>

                {/* Поиск и кнопки управления доступными деталями */}
                <div className="mb-2 space-y-2">
                  <div className="flex gap-2">
                    <input
                      type="text"
                      value={availableDetailsSearch}
                      onChange={(e) => setAvailableDetailsSearch(e.target.value)}
                      placeholder="Поиск по номеру заказа или детали..."
                      className="flex-1 px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                    <button
                      onClick={() => {
                        setAvailableDetails(availableDetails.map(d => ({ ...d, isSelected: true, quantity: d.quantity || d.maxQuantity })));
                      }}
                      className="px-3 py-2 bg-green-500 text-white rounded-lg text-sm hover:bg-green-600 whitespace-nowrap"
                    >
                      Выбрать все
                    </button>
                    <button
                      onClick={() => {
                        setAvailableDetails(availableDetails.map(d => ({ ...d, isSelected: false, quantity: 0 })));
                      }}
                      className="px-3 py-2 bg-red-500 text-white rounded-lg text-sm hover:bg-red-600 whitespace-nowrap"
                    >
                      Очистить все
                    </button>
                  </div>
                  <button
                    onClick={handleAddToTrip}
                    disabled={availableDetails.filter(d => d.isSelected && d.quantity > 0).length === 0}
                    className="w-full px-3 py-2 bg-blue-500 text-white rounded-lg text-sm hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    ➕ Добавить выбранные в рейс
                  </button>
                </div>

                {/* Список доступных деталей */}
                <div className="border-2 border-green-300 rounded-lg p-3 bg-green-50 max-h-96 overflow-y-auto">
                  {loadingAvailableDetailsInModal ? (
                    <div className="flex flex-col items-center justify-center py-12">
                      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600 mb-4"></div>
                      <p className="text-gray-600 text-sm">Загрузка доступных деталей...</p>
                    </div>
                  ) : Object.entries(groupedAvailableDetails).length > 0 ? (
                    <div className="space-y-4">
                      {Object.entries(groupedAvailableDetails).map(([orderId, details]) => (
                        <div key={orderId} className="border border-gray-200 rounded-lg p-3 bg-white">
                          <h4 className="text-xs font-semibold text-gray-800 mb-2">
                            Заказ №{details[0].orderNumber}
                          </h4>
                          <div className="space-y-2">
                            {details.map((detail) => (
                              <div
                                key={detail.originalIndex}
                                className={`flex items-center justify-between p-2 rounded text-xs ${
                                  detail.isSelected
                                    ? 'bg-green-50 border border-green-200'
                                    : 'bg-gray-50 border border-gray-200'
                                }`}
                              >
                                <div className="flex items-center gap-2 flex-1">
                                  <input
                                    type="checkbox"
                                    checked={detail.isSelected}
                                    onChange={() => handleAvailableDetailToggle(detail.originalIndex)}
                                    className="w-4 h-4 text-green-600 rounded focus:ring-2 focus:ring-green-500 cursor-pointer"
                                  />
                                  <div className="flex-1">
                                    <p className="text-gray-800">{detail.detailText}</p>
                                    {detail.glassType && (
                                      <span className="inline-block px-2 py-0.5 bg-purple-100 text-purple-700 rounded text-xs mt-1 mr-2">
                                        {detail.glassType}
                                      </span>
                                    )}
                                    <p className="text-gray-500 text-xs mt-1">
                                      Макс. количество: {detail.maxQuantity} шт
                                    </p>
                                  </div>
                                </div>
                                <div className="flex items-center gap-2 ml-4">
                                  <button
                                    onClick={() => handleAvailableDetailQuantityChange(detail.originalIndex, detail.quantity - 1)}
                                    disabled={detail.quantity <= 0}
                                    className="w-6 h-6 rounded bg-red-100 hover:bg-red-200 text-red-600 text-xs font-bold disabled:opacity-50"
                                  >
                                    −
                                  </button>
                                  <span className="min-w-[2rem] text-center font-medium">
                                    {detail.quantity}
                                  </span>
                                  <button
                                    onClick={() => handleAvailableDetailQuantityChange(detail.originalIndex, detail.quantity + 1)}
                                    disabled={detail.quantity >= detail.maxQuantity}
                                    className="w-6 h-6 rounded bg-green-100 hover:bg-green-200 text-green-600 text-xs font-bold disabled:opacity-50"
                                  >
                                    +
                                  </button>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="text-center py-8 text-gray-500">
                      <p>
                        {availableDetailsSearch
                          ? 'Ничего не найдено по запросу'
                          : 'Нет доступных деталей для добавления'}
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Футер с кнопками */}
            <div className="flex justify-between items-center gap-2 p-4 border-t">
              <button
                onClick={handleGeneratePartnerPDF}
                disabled={generatingPartnerPDF || tripDetails.filter(d => d.isSelected).length === 0 || loadingTripDetailsInModal}
                className="px-4 py-2 text-sm bg-purple-500 hover:bg-purple-600 text-white rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                title="Сгенерировать отчет партнера для выбранных деталей"
              >
                {generatingPartnerPDF ? '⏳ Генерация...' : '📄 Отчет партнера'}
              </button>
              <div className="flex gap-2">
                <button
                  onClick={() => {
                    setShowTripModal(false);
                    setEditingTrip(null);
                    setLoadingTripDetailsInModal(false);
                    setLoadingAvailableDetailsInModal(false);
                  }}
                  className="px-4 py-2 text-sm bg-gray-200 hover:bg-gray-300 rounded transition-colors"
                  disabled={creatingTrip}
                >
                  Отмена
                </button>
                <button
                  onClick={() => handleSaveTrip()}
                  disabled={creatingTrip || tripDetails.length === 0}
                  className="px-4 py-2 text-sm bg-blue-500 hover:bg-blue-600 text-white rounded transition-colors disabled:opacity-50"
                >
                  {creatingTrip ? 'Сохранение...' : 'Сохранить'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ZakalkaTripsPage;
